import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-circular-loader',
    imports: [],
    templateUrl: './circular-loader.component.html',
    styleUrls: ['./circular-loader.component.scss']
})
export class CircularLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
